import script from "./CollisionSimulator.vue?vue&type=script&setup=true&lang=js"
export * from "./CollisionSimulator.vue?vue&type=script&setup=true&lang=js"

import "./CollisionSimulator.vue?vue&type=style&index=0&id=4a896f6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a896f6c"]])

export default __exports__